const A = "/assets/";

export const BRANDS = [
  {
    slug: "guess-clothing",
    name: "Guess",
    sub: "Clothing",
    category: "Apparel",
    origin: "Los Angeles · 1981",
    collections: "Guess Apparel Men / Women",
    cover: A + "GUESAW26WW.jpg",
    reel: { name: "guess-clothing", title: "AW26 Womenswear" },
    gallery: [A + "GUESSAW26WW4.jpg", A + "GUESAW26WW.jpg"],
    story: [
      "GUESS was established in 1981 by the Marciano brothers, who left the south of France in pursuit of the American dream. Inspired by a European influence, the Marcianos redefined denim. One of their initial designs was a stonewashed, slim-fitting jean, the 3-zip Marilyn.",
      "Bloomingdale's was the first department store to welcome the brand by ordering two dozen pairs of jeans. They disappeared from the shelves in just hours. Today GUESS is a truly global lifestyle brand with a full range of denim, apparel and accessories offered in over 80 countries.",
    ],
  },
  {
    slug: "joop",
    name: "JOOP!",
    sub: "& Joop Jeans",
    category: "Premium",
    origin: "Germany · 1978",
    collections: "Joop & Joop Jeans Men / Women",
    cover: A + "joop-women.jpg",
    reel: { name: "joop", title: "Fall / Winter 2026" },
    gallery: [A + "joop-men.jpg", A + "joop-women.jpg"],
    story: [
      "Founded by Wolfgang Joop in 1978, JOOP! is a lifestyle brand with German roots, distributed internationally across premium menswear, womenswear, footwear and accessories.",
      "From a cult label known only within Germany to a household name in over 43 countries — its collections are centred on being \u201Chedonistic, authentic, brave, and iconic\u201D, celebrating life with style and passion.",
    ],
  },
  {
    slug: "camper",
    name: "Camper",
    sub: "Mallorca",
    category: "Footwear",
    origin: "Mallorca · 1975",
    collections: "Camper Men / Women / Kids",
    cover: A + "womens.jpg",
    reel: { youtube: "u0G4NRqUHMM", poster: "/assets/reels/camper-short.jpg", title: "Pelotas Soller", vertical: true },
    gallery: [A + "Cam-kids.jpg", A + "womens.jpg"],
    story: [
      "In 1975, Lorenzo Fluxà, the third generation of shoemakers, founded Camper to create footwear that was easy to wear and hard to define.",
      "Camper's first shoe, the Camaleon, was a unisex design inspired by the shoes worn by local Mallorcan farmers. Since the beginning, Camper has offered a unique product — a shoe with history.",
    ],
  },
  {
    slug: "happy-socks",
    name: "Happy Socks",
    sub: "Stockholm",
    category: "Accessories",
    origin: "Sweden · 2008",
    collections: "Happy Socks Men / Women",
    cover: A + "HS261.jpg",
    reel: { youtube: "lBAIkXbSvsQ", poster: "/assets/reels/happy-socks-reel.jpg", title: "Happy Socks × The Beatles" },
    gallery: [A + "HS1.jpg", A + "HS261.jpg"],
    story: [
      "Happy Socks began in 2008 when friends Mikael Söderlindh and Viktor Tell set out \u201Cto spread happiness by turning an everyday essential into a colourful design piece\u201D — with a rigid standard of quality, craftsmanship and creativity.",
      "Collaborations span The Beatles, The Rolling Stones, Keith Haring, David Bowie, Andy Warhol, Disney and more. Today Happy Socks is sold in more than 90 countries and over 10,000 top fashion boutiques.",
    ],
  },
  {
    slug: "g-star",
    name: "G-Star",
    sub: "Raw",
    category: "Denim",
    origin: "Amsterdam · 1989",
    collections: "G-Star Raw Men / Women / Accessories",
    cover: A + "G-STARAW26.jpg",
    reel: { youtube: "cDSkE751pi0", poster: "/assets/reels/gstar-on-form.jpg", title: "On Form — with Burna Boy" },
    gallery: [A + "gstar-elwood.jpg", A + "GS1.jpg"],
    story: [
      "Born in Amsterdam, G-STAR has been dedicated to the cloth, the craft and the culture of denim since 1989. Untreated raw denim was introduced into the fashion world, elevating the fabric into a mature and sophisticated material.",
      "They led the way in anatomic denim — the first-ever 3D-shaped jeans — and partner with visionaries from Pharrell Williams and Anton Corbijn to Marc Newson and Magnus Carlsen.",
    ],
  },
  {
    slug: "heskimo",
    name: "Heskimo",
    sub: "Casual Chic",
    category: "Apparel",
    origin: "Italy · 2015",
    collections: "Heskimo Men",
    cover: A + "HESKIMOAW263.jpg",
    reel: { name: "heskimo", title: "Autumn / Winter 2026" },
    gallery: [A + "HESKIMOAW266.jpg", A + "HESKIMOAW263.jpg"],
    story: [
      "Heskimo is an Italian clothing brand founded in 2015 by two young entrepreneurs, Simone and Luca, for a young and dynamic audience who loves casual chic style.",
      "Made with high-quality materials and a modern, attractive design, the brand is also committed to sustainability, using recycled and sustainable materials.",
    ],
  },
  {
    slug: "tiffosi",
    name: "Tiffosi",
    sub: "Denim",
    category: "Denim",
    origin: "Portugal · 40+ years",
    collections: "Tiffosi Women",
    cover: A + "TIFFOSI-266.jpg",
    reel: { name: "tiffosi", title: "Collection 2026" },
    gallery: [A + "TIFFOSI-263.jpg", A + "TIFFOSI-266.jpg"],
    story: [
      "Tiffosi is a fashion brand specialising in denim development and innovation, with over 40 years of experience — combining the technical know-how of jeans with the latest trends, without neglecting comfort and quality.",
      "Its One Size\u00AE Fits All jeans, voted Product of the Year 2016 by Portuguese consumers, use ultra-elastic fabric that moulds to various sizes and body shapes.",
    ],
  },
  {
    slug: "fantasy-sandals",
    name: "Fantasy",
    sub: "Sandals",
    category: "Footwear",
    origin: "Greece · 1974",
    collections: "Fantasy Sandals",
    cover: A + "FAN-22.jpg",
    reel: { youtube: "RHq5gOEwmiI", poster: "/assets/reels/fantasy-reel.jpg", title: "Fantasy Sandals" },
    gallery: [A + "FS1.jpg", A + "FAN-22.jpg"],
    story: [
      "Founded in 1974 in the production of soles for men's and women's shoes, Fantasy grew to become one of the largest outsole suppliers in Greece.",
      "Its sandals represent modern women seeking to be stylish and comfortable at the same time — with leather anatomic insoles that absorb sweat and support the foot properly.",
    ],
  },
  {
    slug: "guess-handbags-accessories",
    name: "Guess",
    sub: "Handbags & Accessories",
    category: "Accessories",
    origin: "Los Angeles · 1981",
    collections: "Guess Handbags / Accessories / Footwear",
    cover: A + "gUESS26-BAGS1.jpg",
    reel: { name: "guess-bags", title: "Handbags 2026" },
    gallery: [A + "Guess262.jpg", A + "gUESS26-BAGS1.jpg"],
    story: [
      "From the 3-zip Marilyn jean to a complete lifestyle world, GUESS has grown since 1981 into a global brand offered in over 80 countries.",
      "Handbags, small leather goods, accessories and footwear carry the same European-influenced, Los Angeles-born attitude — shown season by season in our Dundrum showroom.",
    ],
  },
];

export const BRAND_LABELS = BRANDS.map((b) => (b.sub && b.name === "Guess" ? `Guess ${b.sub}` : b.name));

export const getBrand = (slug) => BRANDS.find((b) => b.slug === slug);
